import { useState, useRef } from "react";

interface DrawerImageWithFallbackProps {
  src?: string;
  alt: string;
  className?: string;
}

export function DrawerImageWithFallback({
  src,
  alt,
  className,
}: DrawerImageWithFallbackProps) {
  const [error, setError] = useState(!src);
  const imageRef = useRef<HTMLImageElement>(null);

  const processImageUrl = (
    url: string = "https://placehold.co/400x200?text=Imóvel",
  ) => {
    if (url.includes("resizedimgs.vivareal.com")) {
      const parts = url.split("/");
      const hashIndex = parts.findIndex((part) => part.length === 32);
      if (hashIndex !== -1) {
        const beforeHash = parts.slice(0, hashIndex + 1).join("/");
        const afterHash = parts.slice(hashIndex + 1).join("-");
        return beforeHash + "/" + afterHash;
      }
    }
    return url;
  };

  if (error) {
    return (
      <div
        className={`bg-gray-100 flex items-center justify-center ${className}`}
      >
        <img
          src="/images/placeholder.png"
          alt={"Sem imagem disponível"}
          className="object-cover w-full h-full"
        />
      </div>
    );
  }

  return (
    <div className={`relative ${className}`}>
      <img
        ref={imageRef}
        src={processImageUrl(src)}
        alt={alt}
        className={`${className}`}
        onError={() => setError(true)}
        loading="lazy"
        decoding="async"
      />
    </div>
  );
}
